module.exports = __webpack_public_path__ + "assets/LMidpoint.aca5d7e14213d34eeefdcd9308c60a17.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/LMidpoint.gmt
// module id = 965
// module chunks = 0